import { ShowSession, ShowSessionType } from '../stores/reducers/session';
import { getHeaders } from './utils';

export const GetShowSessionTypes = (token: string): Promise<ShowSessionType[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/show-sessions/types`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			return [];
		}
	});
};

export const GetShowSessionsByMeetingId = (token: string, meetingId: number): Promise<ShowSession[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/meetings/${meetingId}/show-sessions`, {
		method: 'GET',
		headers: getHeaders(token, meetingId) as any,
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error('Could not load show sessions.');
		}
	});
};

export const AddShowSession = (token: string, showSession: ShowSession): Promise<ShowSession[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/show-sessions`, {
		method: 'POST',
		headers: getHeaders(token) as any,
		body: JSON.stringify(showSession),
	}).then(result => {
		if (result.ok) {
			return GetShowSessionsByMeetingId(token, showSession.meeting);
		} else {
			throw new Error('Could not add show session.');
		}
	});
};

export const EditShowSession = (token: string, showSession: ShowSession): Promise<ShowSession[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/show-sessions`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
		body: JSON.stringify(showSession),
	}).then(result => {
		if (result.ok) {
			return GetShowSessionsByMeetingId(token, showSession.meeting);
		} else {
			throw new Error('Could not edit show session.');
		}
	});
};

export const DeleteShowSession = (token: string, showSession: ShowSession): Promise<ShowSession[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/show-sessions`, {
		method: 'DELETE',
		headers: getHeaders(token) as any,
		body: JSON.stringify({ id: showSession.id }),
	}).then(result => {
		if (result.ok) {
			return GetShowSessionsByMeetingId(token, showSession.meeting);
		} else {
			throw new Error('Could not delete show session.');
		}
	});
};
